const MISCELLANEOUS = {
  pageDataAid: "statements",
  headerDataAid: "statements",
  productTypeInput: {
    dataAid: "productType"
  },
  finYearInput: {
    text: "Select financial year",
    dataAid: "financialYear"
  },
  fromDateInput: {
    text: "From date",
    dataAid: "fromDate"
  },
  toDateInput: {
    text: "To date",
    dataAid: "toDate"
  },
  footerInfoCard: {
    dataAid: "footer"
  },
  footerButton: {
    text: "email statement",
    dataAid: "primary"
  },
  successToastMessage: {
    text: "Statement sent to your registered email"
  }
};

const PAGES = {
  elss: {
    title: {
      text: "80C ELSS statement",
    },
  },
  cgMutualFund: {
    title: {
      text: "Capital gains - Mutual funds statement",
    },
  },
  cgStocks: {
    title: {
      text: "Capital gains - Stocks statement",
    },
    infoText: {
      text: "Statement will be generated for selected financial year period"
    }
  },
  contractNote: {
    title: {
      text: "Contract note statement",
    },
    infoText: {
      text: "Contract notes can only be generated for a 31-day period per request"
    }
  },
  profitAndLoss: {
    title: {
      text: "P&L statement",
    },
  },
  stocksTransaction: {
    title: {
      text: "Transactions - Stocks statement",
    },
  },
  ledger: {
    title: {
      text: "Ledger statement",
    },
  },
  dematHolding: {
    title: {
      text: "Demat holdings statement",
    },
    infoText: {
      text: "Statement will be generated as of current date"
    }
  },
  portfolio: {
    title: {
      text: "Portfolio statement",
    },
  },
  mfTransaction: {
    title: {
      text: "Transactions - Mutual fund statement",
    },
  }
};

const GENERATE_STATEMENTS = {
  MISCELLANEOUS,
  PAGES
};

export default GENERATE_STATEMENTS;